import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { encryptPayload, decryptResponse } from '../CryptoUtil';
import { APP_URL, withCredentials } from '../../App';

const DynamicTableAction = (props) => {
  const navigate = useNavigate();

  const handleAction = async (action, singleImei) => {
    try {
      const session = JSON.parse(localStorage.getItem("userSession"));
      const payload = decryptResponse(session.data.payload, session.data.transactionId);

      const response = await axios.post(
        `${APP_URL}locknotification.php`,
        encryptPayload({
          imei: singleImei,
          action: action,
          clientof: props.clientof,
          retailerNumber: payload.retailer_phone,
          user: payload.retailer_phone
        }),
        {
          withCredentials: withCredentials,
          headers: {
            'Content-Type': 'application/json',
            'X-API-Key': payload.token
          }
        }
      );

      const result = decryptResponse(response.data.payload, response.data.transactionId);

      if (result.status === 'success') {
        alert(`${action} App initiated successfully.`);
      } else {
        if (result.message.includes('Authorization Failed')) {
          localStorage.clear();
          navigate('/');
        } else {
          alert(result.message);
        }
      }
    } catch (error) {
      console.error('Action failed:', error);
    }
  };

  if (!props.data || props.data.length === 0) {
    return <p className="text-danger">No data available</p>;
  }

  // Get all keys from data
  const allKeys = Array.from(new Set(props.data.flatMap(item => Object.keys(item))));

  return (
    <div style={{ height: props.height || '350px', overflow: 'auto' }}>
      <table className="table table-bordered table-striped mt-3">
        <thead>
          <tr>
            <th>S.No.</th>
            {props.action && <th>Action</th>}
            {allKeys.map((key) => (
              <th key={key}>{key.toUpperCase()}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {props.data.map((item, index) => (
            <tr key={item.imei || index}>
              <td>{index + 1}</td>
              {props.action && (
                <td>
                  <button
                    className="btn btn-success btn-sm me-2"
                    onClick={() => handleAction(props.action, item.imei)}
                  >
                    {props.actionname || 'Action'}
                  </button>
                </td>
              )}
              {allKeys.map((key) => (
                <td key={key}>{item[key] ?? ''}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

DynamicTableAction.displayName = 'DynamicTableAction';
export default DynamicTableAction;
  